import { Typography } from '@app/components';

// admin-emailbeheer blok B. Matches admin-email-mockup_3.html's .tile: white card, large
// tabular-nums value, and either a coloured status line (icon + text) or a muted foot note -
// never colour alone (opdracht §4).
export type EmailKpiTileStatusTone = 'ok' | 'warn' | 'bad';

const STATUS_TEXT_COLOR: Record<EmailKpiTileStatusTone, string> = {
  ok: 'text-accept-text',
  warn: 'text-[#8a6d00]',
  bad: 'text-[#c23c3c]',
};

export const EmailKpiTile: React.FC<{
  label: string;
  value: string;
  status?: { tone: EmailKpiTileStatusTone; icon: React.ReactNode; text: string };
  foot?: string;
}> = ({ label, value, status, foot }) => (
  <div className="rounded-md bg-white p-4 shadow-card">
    <Typography variant="xxs" className="text-gray-400">
      {label}
    </Typography>
    <div className="text-[26px] font-bold leading-tight tracking-tight text-gray-800 [font-variant-numeric:tabular-nums]">
      {value}
    </div>
    {status && (
      <div className={`mt-1.5 flex items-center gap-1 text-[11.5px] font-semibold ${STATUS_TEXT_COLOR[status.tone]}`}>
        {status.icon}
        {status.text}
      </div>
    )}
    {!status && foot && (
      <Typography variant="xxs" className="mt-1.5 text-gray-400">
        {foot}
      </Typography>
    )}
  </div>
);
